// removed by extract-text-webpack-plugin
module.exports = {"Table":"CtorL","TableSimple":"ipoXK"};


//////////////////
// WEBPACK FOOTER
// ./visualizations/components/Table.css
// module id = 1363
// module chunks = 0 3 5